module.exports = __webpack_public_path__ + "img/topup-saldo.8230c869.png";